import {Page} from 'utils/page-utils';
import CMSUtils, {CustomTypes} from 'utils/cms';
import {initialState as searchRequestInitialState} from 'store/search-request/search-request-reducer';

const getInitialState = async ({state, cookies, params: {slug}}) => ({
    ...state,
    searchRequest: {
        ...searchRequestInitialState,
        pageType: Page.LEGAL,
    },
    page: await CMSUtils.getPageData({
        cookies,
        slug,
        customType: CustomTypes.LEGAL,
    }),
});

export default getInitialState;
